import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { Observable } from 'rxjs';
import { inSkipList } from '.';
import { AuthService } from '../auth/auth.service';

@Injectable()
export class HttpHeadersInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService, private translocoService: TranslocoService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const headers = <any>{
      'Accept-Language': this.translocoService.getActiveLang(),
    };

    if (!inSkipList(req.url)) {
      headers.Authorization = `Bearer ${this.authService.getAccessToken()}`;
    }

    return next.handle(req.clone({ setHeaders: headers }));
  }
}
